




































import Vue from 'vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XDialog from '@/components/atoms/Dialog/XDialog.vue'
import AgentDestinationList from '@/components/molecules/FfpAgent/Destination/AgentDestinationList.vue'
import AgentDestinationForm from '@/components/molecules/FfpAgent/Destination/AgentDestinationForm.vue'
import { AgentSalesDestination } from '@/types/generated/graphql'

type Data = {
  name: string
  showForm: boolean
}

type Props = {
  partnerId: string
  storeId: string
}

type Methods = {
  open: () => void
  close: () => void
  creating: () => void
  listing: () => void
  onSelectDestination: (destination: AgentSalesDestination) => void
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: 'AgentDestinationPicker',
  components: {
    XButton,
    XDialog,
    AgentDestinationList,
    AgentDestinationForm,
  },
  data: function () {
    return {
      name: 'AgentDestinationPicker',
      showForm: false,
    }
  },
  props: {
    partnerId: {
      type: String,
      required: true,
    },
    storeId: {
      type: String,
      required: true,
    },
  },
  methods: {
    open() {
      this.$modal.show(this.name)
    },
    close() {
      this.listing()
      this.$modal.hide(this.name)
    },
    creating() {
      this.showForm = true
    },
    listing() {
      this.showForm = false
    },
    onSelectDestination(destination: AgentSalesDestination) {
      this.$emit('select:destination', destination)
      this.close()
    },
  },
})
